import { redirect } from "react-router-dom";

const TOKEN_KEY = 'token';
const ROLE_KEY = 'role';
const EXPIRATION_KEY = 'expiration';
const USER_ID_KEY = 'userId';
const USER_NAME_KEY = 'userName';
const TENANT_KEY = 'tenantOrClientId';
const THEME_KEY = 'appTheme';

export function getStoredAuthData() {
  const token = localStorage.getItem(TOKEN_KEY);
  const role = localStorage.getItem(ROLE_KEY);
  const expiration = localStorage.getItem(EXPIRATION_KEY);
  const userId = localStorage.getItem(USER_ID_KEY);
  const userName = localStorage.getItem(USER_NAME_KEY);
  const tenantOrClientId = localStorage.getItem(TENANT_KEY);

  return {
    token,
    role,
    expiration,
    userId,
    userName,
    tenantOrClientId
  };
}

export function setStoredAuthData(data) {
  if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
  if (data.role) localStorage.setItem(ROLE_KEY, data.role);
  if (data.expiration) localStorage.setItem(EXPIRATION_KEY, data.expiration);
  if (data.userId) localStorage.setItem(USER_ID_KEY, data.userId);
  if (data.userName) localStorage.setItem(USER_NAME_KEY, data.userName);
  if (data.tenantOrClientId) localStorage.setItem(TENANT_KEY, data.tenantOrClientId);
}

export function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export function getTokenDuration() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return -1;

  const decodedToken = parseJwt(token);
  if (decodedToken && decodedToken.exp) {
    const expirationDate = new Date(decodedToken.exp * 1000);
    const now = new Date();
    return expirationDate.getTime() - now.getTime();
  }

  const storedExpirationDate = localStorage.getItem(EXPIRATION_KEY);
  if (!storedExpirationDate) return -1;
  const expirationDate = new Date(storedExpirationDate);
  const now = new Date();
  const duration = expirationDate.getTime() - now.getTime();
  return duration;
}

export function getAuthToken() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return null;
  }

  const tokenDuration = getTokenDuration();

  if (tokenDuration <= 0) {
    return 'EXPIRED';
  }

  return token;
}

export function tokenLoader() {
  return getAuthToken();
}

export function checkAuthLoader() {
  const token = getAuthToken();

  if (!token || token === 'EXPIRED') {
    return redirect('/');
  }
}

export function getUserRole() {
  const data = getStoredAuthData();
  if (!data.token) {
    return null;
  }

  const tokenDuration = getTokenDuration();

  if (tokenDuration < 0) {
    return 'EXPIRED';
  }

  return data.role;
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(EXPIRATION_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(USER_NAME_KEY);
  localStorage.removeItem(TENANT_KEY);
}
